<div class="box box-experience">
    <router-outlet></router-outlet>
</div>
